var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUpBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5737 7.01462L12.4486 7.61639H13.0633H18.7C19.4065 7.61639 19.9866 8.1965 19.9866 8.90299V10.6896C19.9866 10.8524 19.9563 11.003 19.8986 11.1526L17.2042 17.4426L17.2041 17.4426L17.2022 17.4472C17.0102 17.908 16.5554 18.2293 16.0201 18.2293H7.98039C7.2739 18.2293 6.69379 17.6492 6.69379 16.9427V8.00969C6.69379 7.65447 6.83493 7.33673 7.06951 7.1085L7.06955 7.10853L7.07466 7.10342L12.6007 1.56898L13.1921 2.1548C13.1924 2.15505 13.1926 2.15531 13.1929 2.15557C13.3394 2.30248 13.4329 2.50773 13.4384 2.72753L13.4167 2.95956L12.5737 7.01462ZM3.90719 8.50969V18.2293H1.33398V8.50969H3.90719Z",
    fill: "#2086E3",
    stroke: "#2086E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpBlue);
export default __webpack_public_path__ + "static/media/thumbs-up-blue.9c78848d.svg";
export { ForwardRef as ReactComponent };